import React, { FC, ReactElement, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { localizeType } from '../../commonType';
import { setBonvoyValue, setIIValue } from '../../features/offerConfirmation/offerConfirmationSlice';
import { RootState } from '../../redux/rootReducer';
import withLocalization from '../hoc/withLocalization';
import Partners from './Partners';

interface prospectMembershipType {
  localize: localizeType;
}
const BONVOY_ID_MAX_LENGTH = 15;
const BONVOY_ID_VALIDATION = new RegExp('^\\d{9,15}?$');

const II_MAX_LENGTH = 15;
const II_VALIDATION = new RegExp('^\\d{9,15}?$');

const ProspectMembership: FC<prospectMembershipType> = (props: prospectMembershipType): ReactElement => {
  const { localize } = props;
  const bonvoymembershipValueFromStore = useSelector((state: RootState) => state.confirmation.bonvoyValue);
  const IIValueFromStore = useSelector((state: RootState) => state.confirmation.IIValue);
  const [bonvoymembershipValue, setBonvoymembershipValue] = useState(bonvoymembershipValueFromStore ?? '');
  const [IImembershipValue, setIImembershipValue] = useState(IIValueFromStore ?? '');

  const [bonvoyMembershipError, setBonvoyMembershipError] = useState('');
  const [IIMembershipError, setIIMembershipError] = useState('');
  const membershipRef = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();

  const onBonvoyMembershipIdChange = (e) => {
    if (e && e.target && e.target.value) {
      const bonvoyId = e.target.value;
      if (BONVOY_ID_VALIDATION.test(bonvoyId)) {
        setBonvoymembershipValue(bonvoyId);
        setBonvoyMembershipError('');
      } else {
        setBonvoymembershipValue('');
        setBonvoyMembershipError('preview-sales-engine.static-content.copy.Confirmation Page.bonvoy-error-message');
      }
    } else {
      setBonvoymembershipValue('');
      setBonvoyMembershipError('preview-sales-engine.static-content.copy.Confirmation Page.bonvoy-error-message');
    }
  };
  const onBonvoyBlur = () => {
    if (bonvoymembershipValue && bonvoymembershipValue.length > 0) {
      if (BONVOY_ID_VALIDATION.test(bonvoymembershipValue)) {
        dispatch(setBonvoyValue(bonvoymembershipValue));
      } else {
        dispatch(setBonvoyValue(''));
      }
    } else {
      dispatch(setBonvoyValue(''));
    }
  };
  const onIIMembershipIdChange = (e) => {
    if (e && e.target && e.target.value) {
      const bonvoyId = e.target.value;
      if (II_VALIDATION.test(bonvoyId)) {
        setIImembershipValue(bonvoyId);
        setIIMembershipError('');
      } else {
        setIImembershipValue('');
        setIIMembershipError('preview-sales-engine.static-content.copy.Confirmation Page.interval-error-message');
      }
    } else {
      setIImembershipValue('');
      setIIMembershipError('preview-sales-engine.static-content.copy.Confirmation Page.interval-error-message');
    }
  };
  const onIIBlur = () => {
    if (IImembershipValue && IImembershipValue.length > 0) {
      if (II_VALIDATION.test(IImembershipValue)) {
        dispatch(setIIValue(IImembershipValue));
      } else {
        dispatch(setIIValue(''));
      }
    } else {
      dispatch(setIIValue(''));
    }
  };
  return (
    <>
      <hr />
      <h5 className="membershipHeader">
        {localize('preview-sales-engine.static-content.copy.Confirmation Page.membership-header')}
      </h5>
      <div className="row membershipWrapper">
        <div className="col-md-6">
          <label htmlFor="bonvoymembershipId">
            {localize('preview-sales-engine.static-content.copy.Confirmation Page.bonvoy-membership-number')}{' '}
            <input
              id="bonvoymembershipId"
              type="text"
              maxLength={BONVOY_ID_MAX_LENGTH}
              onChange={onBonvoyMembershipIdChange}
              onBlur={onBonvoyBlur}
              defaultValue={bonvoymembershipValue}
              ref={membershipRef}
            ></input>
            <span className="invalid-feedback-onchange">{localize(bonvoyMembershipError)}</span>
          </label>
        </div>
        <div className="col-md-6">
          <label htmlFor="intervalInternational">
            {localize('preview-sales-engine.static-content.copy.Confirmation Page.interval-international')}{' '}
            <input
              id="intervalInternational"
              type="text"
              maxLength={II_MAX_LENGTH}
              onChange={onIIMembershipIdChange}
              onBlur={onIIBlur}
              defaultValue={IImembershipValue}
              ref={membershipRef}
            ></input>
            <span className="invalid-feedback-onchange">{localize(IIMembershipError)}</span>
          </label>
        </div>
      </div>
      <div>
        <Partners></Partners>
      </div>
    </>
  );
};

export default withLocalization(ProspectMembership);
